import React, { Component } from 'react';

class Adsense320100 extends Component {

  componentDidMount() {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }
  
  render() {
    return (
      <ins className="adsbygoogle ad320100"
        style={{display:'inline-block', width: '320px', height: '100px'}}
        data-ad-client="ca-pub-1407998984163880"
        data-ad-slot="1164833709"
      ></ins>
    );
  }
}

export default Adsense320100;